
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reboot",
      function () {
        return require("private-next-pages/reboot/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reboot"])
      });
    }
  